
















































































































































































































































































































































































































































































































































































































































import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  reactive
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import LoginKey from "@/components/login-key";
import router from '../../../router'
export default createComponent({
  props: {
	  token: {
      type: String
    },
  } as const,
  setup(props) {
    const state = reactive({
      confirmCheck: false
    })
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const login = inject(LoginKey);
    if (!login) {
      throw new Error(`${LoginKey} is not provided`);
    }
    const dialogConfirm = computed(() => displayui.dialogConfirmAccount);
    const closeDialog = displayui.closeDialogConfirmAccount
    const confirmCompany = async () => {
      const changeFlag = login.changeAgreementFlag("JWT " + props.token) as any
      if(changeFlag.data){
        await displayui.openDialogLoginError()
      }else {
        await window.localStorage.setItem('token', "JWT " + props.token)
        await router.push('/company_detail')
      }
    }
    return {
      dialogConfirm,
      closeDialog,
      confirmCompany,
      state
    };
  },
  components: {
  },
})
